<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="grid grid-cols-1 tb:grid-cols-2 gap-5 tb:mt-0 mt-8">
        <ng-container *ngIf="!(previewData?.found_admissions?.length || previewData?.not_found_admissions?.length)">
            <sms-autocomplete
                class="tb:col-span-2 col-span-1"
                [options]="examsOptions"
                formControlName="exam"
                field="name"
                label="Exam"
            ></sms-autocomplete>

            <!-- <sms-text-input class="tb:col-span-2 col-span-1" formControlName="title" label="Title"></sms-text-input>
            <sms-rich-text-editor
                class="tb:col-span-2 col-span-1"
                [required]="true"
                [control]="$any(formGroup.controls['description'])"
                label="Description"
            ></sms-rich-text-editor> -->
            <sms-alert class="col-span-full"
                >Please upload PDF files named with the student's admission number in the format ADMXXXX (e.g.,
                ADM1023.pdf)</sms-alert
            >
            <sms-file-input
                class="tb:col-span-2 col-span-1"
                [multiple]="true"
                [preserveFiles]="true"
                formControlName="attachments"
                label="Add Result Pdf's"
                accept="application/pdf"
            ></sms-file-input>
        </ng-container>

        <div
            class="grid gap-3 col-span-full"
            *ngIf="previewData?.found_admissions || previewData?.not_found_admissions"
        >
            <p-accordion>
                <sms-accordion-tab [selected]="true" header="Admissions Found">
                    <!-- <div
                        class="flex justify-between items-center cursor-pointer hover:bg-primary-light gap-3 border-b border-b-gray-100 px-1 py-2"
                        *ngFor="let item of previewData?.found_admissions"
                    >
                        <div>
                            <div class="text-sm font-satosh text-active font-bold">
                                {{ item.form_number }} - {{ item?.student_name }}
                            </div>
                        </div>
                    </div> -->
                    <sms-alert
                        >The following students/admissions were successfully matched with the uploaded files in this
                        classroom.</sms-alert
                    >
                    <div class="mt-2" *ngFor="let item of previewData?.found_admissions">
                        <div class="flex justify-between items-start gap-2 mb-1.5 border-b border-b-gray-100 py-0.5">
                            <div class="flex justify-start items-start gap-2">
                                <div
                                    class="flex justify-center items-center gap-2/5 p-2 bg-primary-light rounded-m w-12"
                                >
                                    <i class="ph-duotone ph-student text-primary text-2xl"></i>
                                </div>
                                <div class="flex flex-col gap-1 justify-center">
                                    <h1 class="font-satoshi font-bold text-base leading-5 text-heading line-clamp-1">
                                        {{ item?.student_name }}
                                    </h1>
                                    <p
                                        class="m-0 text-xs font-medium leading-3 line-clamp-1 font-satoshi text-placeholder"
                                        [innerHtml]="item?.form_number"
                                    ></p>
                                    <p
                                        class="m-0 text-[10px] font-medium leading-3 text-primary"
                                        *ngIf="item.roll_number"
                                    >
                                        Roll No: {{ item.roll_number }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </sms-accordion-tab>

                <sms-accordion-tab
                    *ngIf="previewData?.not_found_admissions?.length"
                    [selected]="true"
                    header="Admissions Not Found"
                >
                    <sms-alert
                        >The following files couldn’t be matched with any students in this classroom. Please verify the
                        details and re-upload if needed.</sms-alert
                    >
                    <div
                        class="flex justify-between items-center cursor-pointer hover:bg-primary-light gap-3 border-b border-b-gray-100 px-1 py-2 mt-2"
                        *ngFor="let item of previewData?.not_found_admissions"
                    >
                        <div>
                            <div class="text-sm font-satosh text-active font-bold">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </sms-accordion-tab>
            </p-accordion>
        </div>

        <!-- Upload Progress Indicator -->
        <div
            class="col-span-full bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 mb-4 shadow-sm"
            *ngIf="isUploading"
        >
            <div class="text-center">
                <!-- Spinner -->
                <div class="flex justify-center mb-4">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                </div>

                <!-- Progress Text -->
                <div class="mb-4">
                    <div class="text-lg font-semibold text-blue-800 mb-2">Uploading Files...</div>
                    <div class="text-sm text-blue-600 font-medium">
                        {{ uploadProgress }}
                    </div>
                    <div class="text-xs text-blue-500 mt-1 truncate max-w-md mx-auto">
                        {{ currentUploadFile }}
                    </div>
                </div>

                <!-- Progress Bar -->
                <div class="w-full bg-blue-200 rounded-full h-2 mb-2">
                    <div
                        class="bg-blue-600 h-2 rounded-full transition-all duration-300 ease-out"
                        [style.width.%]="(currentFileIndex / totalFiles) * 100"
                    ></div>
                </div>

                <!-- Percentage -->
                <div class="text-xs text-blue-500 font-medium">
                    {{ (currentFileIndex / totalFiles) * 100 | number: "1.0-0" }}% Complete
                </div>
            </div>
        </div>

        <ng-container>
            <button
                *ngIf="!(previewData?.found_admissions?.length || previewData?.not_found_admissions?.length)"
                [loading]="isLoading$ | async"
                [disabled]="isLoading$ | async"
                (click)="onPreview()"
                smsButton
                type="button"
            >
                <ng-container>
                    <i class="ph-bold ph-upload-simple"></i>
                    Preview
                </ng-container>
            </button>

            <button
                class="tb:col-span-full"
                *ngIf="previewData?.found_admissions?.length"
                [loading]="(isLoading$ | async) || isUploading"
                [disabled]="(isLoading$ | async) || isUploading"
                (click)="onGenerateUrl()"
                smsButton
                type="button"
            >
                <ng-container>
                    <i class="ph-bold ph-upload-simple"></i>
                    Upload
                </ng-container>
            </button>

            <button
                *ngIf="previewData?.found_admissions?.length || previewData?.not_found_admissions?.length"
                [variant]="'outlined'"
                (click)="goToForm()"
                smsButton
            >
                Go Back
            </button>

            <button [variant]="'outlined'" [routerLink]="['../']" smsButton>Close</button>
        </ng-container>

        <!-- <button [loading]="isLoading$ | async" smsButton type="submit">
            <ng-container>
                <i class="ph-bold ph-upload-simple"></i>
                Preview
            </ng-container>
        </button> -->
    </div>
</form>
